import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'
import { localStorageKeys } from '~/adapter/localstorage/keys'

export type TabType = 'schedule' | 'productMaster' | 'template'

export type State = {
  tabType: TabType
}

const initialState: State = {
  tabType: 'schedule',
}

export type Actions = {
  handleClickTab: (tabType: TabType) => void
  logoutHomeTab: () => void
}

export const HomeTabStoreName = localStorageKeys.homeTabStore

/**
 * Home画面のタブの選択状態を保持する store。
 * ローカルストレージと同期される
 */
export const useHomeTabStore = create<State & Actions>()(
  devtools(
    immer(
      persist(
        set => ({
          ...initialState,
          handleClickTab: (tabType: TabType) => {
            set(state => {
              state.tabType = tabType
            })
          },
          logoutHomeTab: () => {
            set(state => {
              state.tabType = initialState.tabType
            })
          },
        }),
        {
          name: HomeTabStoreName,
          version: 0,
        },
      ),
    ),
  ),
)
